function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 12C24 18.6269 18.6277 24 12 24C5.37232 24 0 18.6269 0 12C0 5.37232 5.37232 0 12 0C18.6277 0 24 5.37232 24 12Z",
  fill: "#8B8B8B"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 5.33342C11.7699 5.33342 11.5837 5.14666 11.5837 4.91658V2.41658C11.5837 2.18645 11.7699 2 12 2C12.2307 2 12.4169 2.18645 12.4169 2.41658V4.91658C12.4169 5.14666 12.2307 5.33342 12 5.33342Z",
  fill: "#F6BB42"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 22C12 22 12.0006 22 12 22C11.7705 22 11.5837 21.8132 11.5837 21.5837V19.0838C11.5837 18.8531 11.7705 18.6663 12.0006 18.6663C12.2308 18.6663 12.4169 18.853 12.4169 19.0838V21.5837C12.4169 21.8132 12.2307 22 12 22Z",
  fill: "#F6BB42"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.28607 7.28589C7.1231 7.44855 6.85942 7.44855 6.69707 7.28589L4.92889 5.51803C4.76654 5.35536 4.76654 5.09168 4.92889 4.92902C5.09186 4.76605 5.35554 4.76605 5.51852 4.92902L7.28607 6.69658C7.44904 6.85924 7.44904 7.12323 7.28607 7.28589Z",
  fill: "#FFCE54"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.0715 19.0709C18.9085 19.2339 18.6448 19.2339 18.4819 19.0709L16.7143 17.3033C16.5513 17.1403 16.5513 16.8766 16.7143 16.7143C16.8772 16.5513 17.1409 16.5513 17.3039 16.7143L19.0715 18.4819C19.2338 18.6442 19.2338 18.9079 19.0715 19.0709Z",
  fill: "#FFCE54"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.33378 12C5.33378 12.2301 5.14701 12.4166 4.91689 12.4166H2.41689C2.18676 12.4166 2.00063 12.2301 2 12C2 11.7699 2.18676 11.5834 2.41689 11.5834H4.91689C5.14697 11.5834 5.33378 11.7699 5.33378 12Z",
  fill: "#F6BB42"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9999 12C21.9999 12.2301 21.8137 12.4166 21.5836 12.4166H19.0836C18.8535 12.4166 18.6667 12.2301 18.6667 12C18.6667 11.7699 18.8535 11.5834 19.0836 11.5834H21.5836C21.8137 11.5834 21.9999 11.7699 21.9999 12Z",
  fill: "#F6BB42"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.28607 16.7143C7.44904 16.8767 7.44904 17.1403 7.28607 17.3033L5.51852 19.0709C5.35554 19.2339 5.09186 19.2339 4.92889 19.0709C4.76654 18.9079 4.76654 18.6443 4.92889 18.4819L6.69707 16.7143C6.85942 16.5514 7.1231 16.5514 7.28607 16.7143Z",
  fill: "#FFCE54"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.0715 4.92873C19.0715 4.92905 19.0715 4.92873 19.0715 4.92873C19.2338 5.09167 19.2338 5.35535 19.0715 5.51801L17.3033 7.28588C17.1409 7.44854 16.8772 7.44854 16.7143 7.28588C16.5513 7.12322 16.5513 6.85922 16.7143 6.69656L18.4819 4.92869C18.6448 4.76607 18.9085 4.76607 19.0715 4.92873Z",
  fill: "#FFCE54"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.9997 17.4162C9.0133 17.4162 6.5835 14.987 6.5835 12C6.5835 9.01325 9.0133 6.5834 11.9997 6.5834C14.9868 6.5834 17.4166 9.01325 17.4166 12C17.4166 14.987 14.9868 17.4162 11.9997 17.4162Z",
  fill: "#FFCE54"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.9999 6.1666C8.77843 6.1666 6.16675 8.77828 6.16675 12C6.16675 15.2214 8.77843 17.8338 11.9999 17.8338C15.2219 17.8338 17.8336 15.2214 17.8336 12C17.8336 8.77828 15.2219 6.1666 11.9999 6.1666ZM15.5356 15.5352C14.5914 16.48 13.3359 17 11.9999 17C10.6644 17 9.40892 16.48 8.46471 15.5352C7.5205 14.5916 6.99986 13.3355 6.99986 12C6.99986 10.6646 7.5205 9.40877 8.46471 8.46456C9.40892 7.52007 10.6644 7.00002 11.9999 7.00002C13.3359 7.00002 14.5914 7.52007 15.5356 8.46456C16.4798 9.40877 16.9999 10.6646 16.9999 12C16.9999 13.3355 16.4798 14.5916 15.5356 15.5352Z",
  fill: "#F6BB42"
});

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.ecafbc86.svg";
export { ForwardRef as ReactComponent };